import { FilterMinusOutlineIcon } from './FilterMinusOutlineIcon';

/**
 * author: GreenTurtwig
 * id 7AB99674-5A9A-40BE-94B4-B8CFA4A97434
 * name filter-minus-outline
 * version: 3.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/filter-minus-outline.svg
 * tags
 */
export const FunnelMinusOutlineIcon = FilterMinusOutlineIcon;
export default FunnelMinusOutlineIcon